import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common/PageHeader";
import { PageLoader } from "@/components/common/Loading";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Briefcase, MessageSquare, GraduationCap, ClipboardCheck, Sparkles, Smartphone, UserCircle, BarChart3, Users } from "lucide-react";

const FEATURES = [
  ["people", "People / CMS", "Master Person records and classifications.", Users],
  ["jobs", "Jobs & Applications", "Job board, applications and career sites.", Briefcase],
  ["communications", "Communications", "Email and shared recruiting inbox.", MessageSquare],
  ["sms", "SMS Messaging", "Text messaging to candidates.", Smartphone],
  ["candidate_portal", "Candidate Portal", "Secure candidate self-service portal.", UserCircle],
  ["lms", "Learning Management", "Courses, modules and training.", GraduationCap],
  ["assessments", "Assessments", "Customizable assessment engine.", ClipboardCheck],
  ["ai", "AI Tools", "AI-assisted recruiting features.", Sparkles],
  ["reporting", "Reporting & Analytics", "Dashboards and downloadable reports.", BarChart3],
];

export default function FeatureSettings() {
  const { currentAccount } = useAuth();
  const [features, setFeatures] = useState(null);

  useEffect(() => { api.get("/account/features").then((r) => setFeatures(r.data)).catch((e) => toast.error(apiError(e))); }, [currentAccount]);
  if (!features) return <PageLoader />;

  const toggle = async (key, value) => {
    setFeatures({ ...features, [key]: value });
    try { await api.patch("/account/features", { features: { [key]: value } }); }
    catch (e) { toast.error(apiError(e)); setFeatures(features); }
  };

  return (
    <div>
      <PageHeader title="Feature Settings" description="Enable or disable platform modules for this account. No billing is attached in Phase I." />
      <div className="grid sm:grid-cols-2 gap-3">
        {FEATURES.map(([key, label, desc, Icon]) => (
          <div key={key} className="flex items-start gap-3 rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
            <div className="w-9 h-9 rounded-md bg-slate-100 flex items-center justify-center shrink-0"><Icon className="w-4 h-4 text-[#006090]" /></div>
            <div className="flex-1 min-w-0">
              <p className="font-medium text-slate-800 text-sm">{label}</p>
              <p className="text-xs text-slate-400">{desc}</p>
            </div>
            <Switch checked={!!features[key]} onCheckedChange={(v) => toggle(key, v)} data-testid={`feature-${key}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
